import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-grey w-full py-2.5 shadow-[0px_4px_11px_0px_rgba(29,31,34,0.1)]',
    container: 'container flex flex-col gap-4',
    tabsContainer: 'flex items-center justify-between',
    closeButton: 'flex size-10 cursor-pointer items-center justify-center',
    closeIcon: 'size-8',
    tabTitle:
      'lg:!heading-3xl sm:heading-2xl-desk heading-2xl align-top sm:!leading-none'
  }
});
